import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const home = resolve => require(['../page/index/index.vue'], resolve);
const web = resolve => require(['../page/index/indexweb.vue'], resolve);


export default new Router({
  mode: 'history', // require service support
  routes: [
    //首页
    {
      path: '/index',
      name: 'index',
      component: home
    },
    {
      path: '/web',
      name: 'web',
      component: web
    },
    /* //解决方案
    {
      path: '/soultion',
      name: 'soultion',
      component: soultion
    },
    //关于我们
    {
      path: '/aboutus',
      name: 'aboutus',
      component: aboutus
    },
    //建站方案
    {
      path: '/buildPlan',
      name: 'buildPlan',
      component: buildPlan
    },
    //客户案例
    {
      path: '/customCase',
      name: 'customCase',
      component: customCase
    },
    //联系我们
    {
      path: '/contactUs',
      name: 'contactUs',
      component: contactUs
    } */
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js